import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { FaPlay, FaCheckCircle, FaBuilding, FaUsers, FaLayerGroup, FaChartLine, FaRupeeSign } from "react-icons/fa";
import dashboard from "../Images/dashboards/admin-dashboard.png";
import bumppyLogo from "../Images/company-logos/Bumppy-epp-logo.svg";
import chaafoLogo from "../Images/company-logos/chAafo-logo.svg";
import grownPeLogo from "../Images/company-logos/Grown-Pe.svg";
import shubhPaisaLogo from "../Images/company-logos/Shubh-Paisa-Logo.svg";
import trawloLogo from "../Images/company-logos/Trawlo-Yellow-Green.svg";
import anlookLogo from "../Images/company-logos/anlook-logo.webp";
import packkyLogo from "../Images/company-logos/Packky-logo.png";
import "./Main.css";

const companyLogos = [
  { name: "Bumppy", src: bumppyLogo },
  { name: "chAafo", src: chaafoLogo },
  { name: "GrownPe", src: grownPeLogo },
  { name: "Shubh Paisa", src: shubhPaisaLogo },
  { name: "Trawlo", src: trawloLogo },
  { name: "Anlook", src: anlookLogo },
  { name: "Packky", src: packkyLogo, padded: true },
];

const Main = () => {
  useEffect(() => {
    const currentUrl = window.location.href; 
    const encodedUrl = encodeURIComponent(currentUrl);
  
    const script = document.createElement("script");
    script.src = `https://packky.com/SeoBix/seo_injection.php?webid=cd8435ad15b4e27805d9e08fbaa8d536&url=${encodedUrl}&baseUrl=https%3A%2F%2Fpackky.com`;
    script.async = true;
  
    document.body.appendChild(script);
  
    return () => {
      document.body.removeChild(script);
    };
  }, []);
  useEffect(() => {
    const currentUrl = window.location.href; 
    const encodedUrl = encodeURIComponent(currentUrl);
  
    const script = document.createElement("script");
    script.src = `https://billpunch.com/SeoBix/seo_injection.php?webid=9d59d8c77c932613971c6c6c6af12ce8&url=${encodedUrl}&baseUrl=https%3A%2F%2Fbillpunch.com`;
    script.async = true;
  
    document.body.appendChild(script);
  
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <>
      <section className="billpunch-hero" aria-labelledby="billpunch-hero-title">
        <div className="billpunch-hero__inner">
          <div className="billpunch-hero__copy">
            <span className="billpunch-hero__label">All-in-One HRMS Platform</span>
            <h1 id="billpunch-hero-title">Simplify HR<br />Operations for<br /><span>Multiple Firms</span></h1>
            <p>Manage your people, attendance, leave, payroll and HR operations across multiple companies — all from one powerful platform.</p>
            <div className="billpunch-hero__actions">
              <Link className="billpunch-hero__button billpunch-hero__button--primary" to="/contact_us">Book a Demo <span aria-hidden="true">→</span></Link>
              <a className="billpunch-hero__button billpunch-hero__button--video" href="#successCard"><span className="billpunch-hero__play"><FaPlay aria-hidden="true" /></span>View Features</a>
            </div>
            <ul className="billpunch-hero__checks">
              {["Attendance Tracking", "Payroll & Leave", "Multi-Company Control"].map((text) => <li key={text}><FaCheckCircle aria-hidden="true" />{text}</li>)}
            </ul>
          </div>
          <div className="billpunch-hero__visual">
            <div className="billpunch-hero__halo" aria-hidden="true" />
            <div className="billpunch-hero__callout"><span><FaBuilding aria-hidden="true" /></span><div><strong>Multiple Companies</strong><p>Manage all your firms<br />from one platform</p></div></div>
            <div className="billpunch-hero__payroll"><span><FaRupeeSign aria-hidden="true" /></span><div><p>Payroll Processed</p><strong>₹ 48,50,000</strong><small>for October 2024</small></div></div>
            <div className="billpunch-hero__note" aria-hidden="true">Smarter HR<br />Happier Teams <span>↴</span></div>
            <div className="billpunch-hero__dashboard"><img src={dashboard} alt="BillPunch dashboard showing workforce, attendance and payroll insights" /></div>
          </div>
        </div>
      </section>
      <section className="billpunch-hero-trust" aria-label="BillPunch at a glance">
        <p className="billpunch-hero-trust__intro">Trusted by 200+ growing businesses across India and beyond</p>
        <div className="billpunch-hero-trust__logos" aria-label="Company logos">
          {companyLogos.map(({ name, src, padded }) => (
            <div key={name} className="billpunch-hero-trust__logo">
              <img className={padded ? "billpunch-hero-trust__logo--padded" : undefined} src={src} alt={name} loading="lazy" />
            </div>
          ))}
        </div>
        <div className="billpunch-hero-trust__stats">
          <div><span className="billpunch-hero-trust__icon billpunch-hero-trust__icon--blue"><FaBuilding aria-hidden="true" /></span><p><strong>200+</strong><span>Customers</span></p></div>
          <div><span className="billpunch-hero-trust__icon billpunch-hero-trust__icon--orange"><FaUsers aria-hidden="true" /></span><p><strong>1000+</strong><span>Users</span></p></div>
          <div><span className="billpunch-hero-trust__icon billpunch-hero-trust__icon--purple"><FaLayerGroup aria-hidden="true" /></span><p><strong>40+</strong><span>Modules</span></p></div>
          <div><span className="billpunch-hero-trust__icon billpunch-hero-trust__icon--orange"><FaChartLine aria-hidden="true" /></span><p><strong>One Platform</strong><span>Multiple Firms</span></p></div>
        </div>
      </section>
    </>
  );
};

export default Main;
